<template>
  <div class="user">
    <div style="overflow: auto; height: 95%;">
    <div class="center">
      <div class="center_top">
        <div class="center_img"  >
          <van-image v-if="userInfo.avatarUrl!=''&&userInfo.avatarUrl!=null" :src="userInfo.avatarUrl" round width="4rem" height="4rem"></van-image>
          <van-image  v-else :src="require('@/assets/img/user.png')"   round width="4rem" height="4rem"></van-image>
        </div>
        <div class="center_info">
          <div v-if="userInfo.niceName != ''&& userInfo.niceName!=null" class="center_name">{{userInfo.niceName}}</div>
          <div v-else @click="$router.push('/company')" class="center_name">请登录</div>
          <div  class="center_phone" >我的分享码: <span style="font-weight: 700;color: #ff976a;">{{ userInfo.code }}</span>
          <!-- <span bindtap='divCopyTextClick' style="padding-left: 10px;color: green;"> 复制 </span> -->
        </div>
        </div>
      </div>
      <div class="center_down">
        <!-- <div style="position: absolute;right: 10px; top: 50%;padding-left: 88px; height: 50px" bind:tap="billRechargeDetail">
          <van-icon name="arrow" size="10" />
        </div> -->
        <div class="center_rank">
         <div class="money_desc">{{ moneyFmt(accountInfo.myGrade) }}</div>
        <div class="rank_text">达人算力</div>
        </div>
        <div class="center_rank">
          <div class="money_desc">{{ moneyFmt(accountInfo.teamGrade) }}</div>
          <div class="rank_text">团队算力</div>
        </div>
      </div>
      <div class="center_down" style="position: relative;">
        <!-- <div style="position: absolute;right: 10px; top: 50%;margin-top: -12px;padding-left: 88px; height: 50px" bindtap="incomeDetail">
          <van-icon name="arrow" size="10" />
        </div> -->
        <div class="center_rank">
         <div class="money_desc">￥{{ moneyFmt(accountInfo.incomeAmount) }}</div>
        <div class="rank_text">总佣金</div>
        </div>
        <div class="center_rank">
          <div class="money_desc">＋￥{{ moneyFmt(accountInfo.income) }} </div>
          <div class="rank_text">昨日佣金</div>
        </div>
        
      </div>
      <!-- <van-image src="/static/img/bill.png" class="center_bill" bind:tap="billDetail" mode=""/> -->
    </div>
  

<div class="list">
    <van-cell  @click="onOpen"  is-link class="list_cell">
      <div slot="title">
        <div class="van-cell-text">个人信息<span v-if="isAllInfo" style="color: red;font-size: 12px;padding-left: 10px;">待完善</span></div>
      </div>
      <van-image  :src="require('@/assets/img/user_info.png')" class="icon" slot="icon"  mode="" />
    </van-cell>
    <!-- <van-cell title="我的账单" bindtap="billDetail"  is-link class="list_cell">
      <van-image :src="require('@/assets/img/bill_item.png')" class="icon" slot="icon" mode=""/>
    </van-cell> -->
    <van-cell title="我的佣金"   is-link class="list_cell" @click="$router.push('/income')">
      <van-image :src="require('@/assets/img/income.png')"  class="icon" slot="icon" mode=""/>
    
    </van-cell>
    <van-cell title="我要充值"  is-link class="list_cell" @click="goRecharge">
      <van-image  :src="require('@/assets/img/Recharge.png')"  class="icon" slot="icon" mode=""/>
    </van-cell>
    <van-cell title="我要提现"   is-link class="list_cell" @click="goWithDraw">
      <van-image  :src="require('@/assets/img/draw.png')" class="icon" slot="icon" mode=""/>
    
    </van-cell>
    <van-cell v-if="isAdmin" title="我的待审"   is-link class="list_cell" @click="$router.push('/auditing')">
      <van-image :src="require('@/assets/img/wait.png')"  class="icon" slot="icon" mode=""/>
      <span class="num" v-if="badge > 0 ">{{badge}}</span>
    </van-cell>
    <van-cell v-if="isAdmin" title="发布公告"  class="list_cell" @click="$router.push('/notice')">
      <van-image :src="require('@/assets/img/message.png')" class="icon" slot="icon" mode=""/>
    </van-cell>
    <van-cell title="在线联系" is-link class="list_cell"   @click="$router.push('/contact')">
      <van-image :src="require('@/assets/img/custom.png')"  class="icon" slot="icon" mode=""/>
    </van-cell>
</div>
<div style="width: 100%;height: 10%;">
  <div v-if="isLogin " class="my_logout" style="color: #fff;margin-bottom: calc(110rpx + env(safe-area-inset-bottom));"  @click="logout">退出登录</div>
</div>
<div style="height:60px"></div>
</div>

<van-popup  v-model="show"    position="bottom" round closeable>
  <div class="alert">
    <div class="title">个人信息完善</div>
    <div v-if="userInfo.shareCode" class="alert_item">邀请码: <span style="color: #777777;">{{userInfo.shareCode}}</span></div>
    <div  v-else class="alert_item">邀请码: <input type="text" placeholder="请输入6位的邀请码" maxlength="6" v-model="shareCode"   placeholder-class="placeholder" /></div>
    <div class="alert_item">昵称: <input type="text" placeholder="请输入昵称" maxlength="20" v-model="userInfo.niceName" data-name="userInfo.niceName" bindinput="bindKeyInput" placeholder-class="placeholder"/></div>
   
    <div class="alert_item">姓名: <input type="text" placeholder="请输入真实姓名" maxlength="20" v-model="userInfo.userName "  placeholder-class="placeholder"/></div>
    <div class="alert_item">抖音号: <input type="text" placeholder="请输入抖音号" maxlength="50" v-model="userInfo.tikTokNum"  placeholder-class="placeholder"/></div>
    <div class="alert_item">银行卡号: <input type="text" placeholder="请输入银行卡号" maxlength="20" v-model="userInfo.bankCard"  placeholder-class="placeholder"/></div>
    <div class="alert_item">开户银行: <input type="text" placeholder="请输入开户行信息" maxlength="20" v-model="userInfo.bankName"  placeholder-class="placeholder"/></div>
    <div class="alert_item">手机号: <input type="text" placeholder="请输入手机号" maxlength="11" v-model="userInfo.tel"  placeholder-class="placeholder"/></div>
    <div v-if="userInfo.withOutPassword == null ||  userInfo.withOutPassword.length == 0 "  class="alert_item">提现密码: <input type="text" placeholder="请输入提现密码" maxlength="18" v-model="password"  placeholder-class="placeholder"/></div>
    <div  class="confirm_btn"  @click="release">确认修改</div>
  </div>
</van-popup>
  </div>
</template>

<script>
import { getUserInfo,updateUserInfo,getOfficialAccountInfo,getOfficialWaitExamine } from "@/api/user.js";
import { checkStrNotNull } from "@/utils/common.js";
import { moneyFmt } from "@/utils/moneyUtil";
export default {
  name: "UserPage",
  data() {
    return {
      detail: {},
      userInfo: this.$store.state.user.userInfo,
      niceName:'',
      code:'',
      isAllInfo: false,
      isAdmin: true,
      badge: 0,
      isLogin: true,
      show:false,
      shareCode: '',
      password:'',
      accountInfo: {}
    };
  },
  created() {
    if (this.userInfo) {
       this.getUserInfo();
       this.getWxCodeAccountInfo();
       this.officialWaitExamine();
       if(this.userInfo.userType == 0){
        this.isAdmin = true
       }else {
        this.isAdmin = false
       }
    }
  },
  computed: {
    // isLogin() {
    //   return this.$store.getters.token;
    // },
  },
  methods: {
      getUserInfo() {
      console.log('=========请求用户信息')
      getUserInfo(this.userInfo.id).then(response =>{
        console.log("========返回userinfo======",response);
        this.$store.commit("user/setUserInfo", response.data);
        if(response.code === 200){
        this.userInfo = response.data;
        if(!checkStrNotNull(response.data.shareCode) || !checkStrNotNull(response.data.niceName) || !checkStrNotNull(response.data.userName) ||
         !checkStrNotNull(response.data.tikTokNum) || !checkStrNotNull(response.data.bankCard) || !checkStrNotNull(response.data.bankName) 
         || !checkStrNotNull(response.data.tel) ||  !checkStrNotNull(response.data.withOutPassword)){
              this.isAllInfo = true
        }else {
        this.isAllInfo =  false
        }
      }

      });
      
    },

    goRecharge() {
      if(!checkStrNotNull(this.userInfo.shareCode) ){
        this.$toast.fail({message: '请完善个人信息的邀请码后再试',duration: 3500})
        return;
      }
      this.$router.push('/rechargeable');
    },
    goWithDraw(){
      let total = 0;
      console.log(total)
    if(this.accountInfo.incomeAmount){
      total = this.accountInfo.incomeAmount;
    }
    this.$router.push({ path: '/draw', query: { incomeAmount: total } })
    },

    getWxCodeAccountInfo() {
      console.log('=========请求账户信息')
      getOfficialAccountInfo().then(response =>{
        if(response.code === 200){
          // console.log(response)
            this.accountInfo = response.data;
        }
      });
    },

    officialWaitExamine() {
      getOfficialWaitExamine().then(response =>{
        if(response.code === 200){
            this.badge = response.data;
        }
      });
    },

    
    moneyFmt(num){
       return moneyFmt(num)
    },

    onOpen() {
      let userInfo =this.$store.state.user.userInfo;
      if(checkStrNotNull(userInfo)){
        this.show= true;
        this.userInfo= userInfo;      
    }else{
      // notLogin()
    }
  },
  release() {
      let userInfo = this.userInfo;
      delete userInfo.withOutPassword;
      if (checkStrNotNull(this.shareCode) && this.shareCode.length != 6 ) {
      this.$toast.fail('邀请码错误,请核对')
      return;
      }
      if (checkStrNotNull(this.shareCode)) {
        userInfo.shareCode = this.shareCode
       }
      if(!checkStrNotNull(userInfo.tikTokNum)){
         this.$toast.fail({message: '抖音号必填',duration: 3500})
        return;
      }
      if(checkStrNotNull(userInfo.tikTokNum) && (userInfo.tikTokNum.length < 6 || userInfo.tikTokNum.length >50)){
         this.$toast.fail({message: '抖音号长度不合法',duration: 3500})
        return;
      }
      if (checkStrNotNull(this.password) && this.password.length < 6 ) {
        this.$toast.fail('提现密码必须6位以上')
        return;
     }
     if (checkStrNotNull(this.password)) {
        userInfo.withOutPassword = this.password
     }
     updateUserInfo(userInfo,userInfo.id).then(res => {
      if (res.code == 200) {
        this.onClose();
        this.$toast.success("修改成功")
        setTimeout(() => {
          this.getUserInfo();
        }, 2000)
      } else {
        delete userInfo.withOutPassword;
        if(res.code == 2068){
          this.userInfo.shareCode = "";
        }
        this.$toast.fail(res.msg)
      }
    })
  },

  onClose() {
      this.show = false,
      this.password = '',
      this.shareCode = ''
   },

    logout() {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "你确认要退出吗？",
        })
        .then(() => {
          //退出是一个动作
          this.$store.dispatch('user/logout')
          window.location.href ="/login"
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.user {
  width: 100%;
  height: 100vh;
  background: url(@/assets/img/my_bg.png) no-repeat left center;
  background-size: 100% 100%;
  overflow: hidden;
}

.center {
  width: 85%;
  background: url(@/assets/img/my_info_bg.png) no-repeat left center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 3%;
  border-radius: 8px;
  padding: 20px;
  .center_top {
    display: flex;
    box-sizing: border-box;
    padding-left: 12px;
    align-items: center;

    .center_img {
      width: 104rpx;
      height: 104rpx;

      image {
        width: 100%;
        height: 100%;
      }
    }

    .center_info {
      margin-left: 16px;

      .center_name {
        font-size: 18px;
        color: #f0f1f3;
        font-weight: 500;
        line-height: 25px;
        margin-top: 2px;
      }

      .center_phone {
        font-size: 14px;
        color: #979797;
        line-height: 18px;
        margin-top: 1px;
      }
    }
  }
}

  
  .center_down {
    padding: 1.5% 0;
    display: flex;
    justify-content: space-around;
    .center_rank {
      text-align: center;
      .money_desc {
        font-size: 20px;
        color: #f0f1f3;
        font-weight: 700;
      }
  
      .rank_text {
        font-size: 13px;
        color: #979797;
        font-weight: 400;
        margin-top: 2px;
      }
    }
  }

  .list {
    width: 95%;
    background: url(@/assets/img/my_cell_bg.png) no-repeat left center;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 3%;
    padding: 6%;
    padding-top: 11%;
    .list_cell {
      width: 96%;
      background-color: transparent;
    }

    .icon {
      width: 24px;
      height: 24px;
    }

  .van-cell {
    display: flex;
    align-items: center;
  }

  /* 字体太小 */
  .van-cell__title {
    padding: 7px 9px !important;
    font-size: 18px !important;
    color: #f0f1f3;
  }

  .num {
    margin-right: 3px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    background: #FA4743;
    border-radius: 12px;
    padding: 1px 6px;
  }
}

.my_logout {
  width: 59%;
  height: 82%;
  background: url(@/assets/img/logout_buttom_bg.png) no-repeat left center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 5%;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert {
  padding-bottom: 2%;
  background-color: #171924;
  color:#e8e8e8;
}
.title {
  font-size: 20px;
  color: #8e8e8e;
  text-align: center;
  font-weight: 700;
  padding-top: 17px;
  }

.alert_item {
    display: flex;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    height: 48px;
    border-bottom: 1px #676767 solid;
    font-size: 20px;

    .df {
      display: flex;
    }

    .alert_item_type {
      padding: 5px 11px;
      border: 1rpx solid rgba(204, 204, 204, 1);
      border-radius: 8px;
      margin-left: 24rpx;
    }
    input {
      flex: 1;
      margin-left: 8px;
      font-size: 18px;
      text-align: right;
      background-color: transparent;
      border: none;
      color: #d1c8c8;
    }

    .placeholder {
      font-size: 16px;
      font-weight: 400;
      color: #BBBBBB;
    }
  }
  .confirm_btn {
    background-color: rgb(3,127,174);
    border-radius: 20px;
    width: 40%;
    margin-top: 5%;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 19px;
    margin-left: 30%;
  }

.head-page {
  height: 130px;
  background: url("http://cba.itlike.com/public/mweb/static/background/user-header2.png");
  background-size: cover;
  display: flex;
  align-items: center;
  .head-img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 10px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.info {
  .mobile {
    margin-bottom: 5px;
    color: #c59a46;
    font-size: 18px;
    font-weight: bold;
  }
  .vip {
    display: inline-block;
    background-color: #3c3c3c;
    padding: 3px 5px;
    border-radius: 5px;
    color: #e0d3b6;
    font-size: 14px;
    .van-icon {
      font-weight: bold;
      color: #ffb632;
    }
  }
}

.my-asset {
  display: flex;
  padding: 20px 0;
  font-size: 14px;
  background-color: #fff;
  .asset-left {
    display: flex;
    justify-content: space-evenly;
    flex: 3;
    .asset-left-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span:first-child {
        margin-bottom: 5px;
        color: #ff0000;
        font-size: 16px;
      }
    }
  }
  .asset-right {
    flex: 1;
    .asset-right-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .van-icon {
        font-size: 24px;
        margin-bottom: 5px;
      }
    }
  }
}

.order-navbar {
  display: flex;
  padding: 15px 0;
  margin: 10px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 5px;
  .order-navbar-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 25%;
    .van-icon {
      font-size: 24px;
      margin-bottom: 5px;
    }
  }
}

.service {
  font-size: 14px;
  background-color: #fff;
  border-radius: 5px;
  margin: 10px;
  .title {
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    font-size: 16px;
  }
  .content {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 14px;
    background-color: #fff;
    border-radius: 5px;
    .content-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 25%;
      margin-bottom: 20px;

      .van-icon {
        font-size: 24px;
        margin-bottom: 5px;
        color: #ff3800;
      }
    }
  }
}

.logout-btn {
  button {
    width: 60%;
    margin: 10px auto;
    display: block;
    font-size: 13px;
    color: #616161;
    border-radius: 9px;
    border: 1px solid #dcdcdc;
    padding: 7px 0;
    text-align: center;
    background-color: #fafafa;
  }
}

.top {
  height: 528rpx;
  // background: #ddd;
  position: relative;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 528rpx;
  }
}

  .center_bill {
    position: absolute;
    top: 65rpx;
    right: 0;
    width: 162rpx;
    height: 52rpx;
  }



</style>